// extracted by css-extract-rspack-plugin
export default {"customVizListItem":"H9nPL","menuContainer":"qwO1T"};